import { useQuery } from '@apollo/client';
import classNames from 'classnames/bind';
import { useRecommendParamsContext } from 'contexts/recommendParams';
import ThemeCard from 'everywhere/common/themeFilter/themeCard';
import { All_THEME } from 'hooks/useThemes';
import { useRouter } from 'next/router';
import GET_RECOMMEND_BY_THEME from '../recommendByTheme.gql';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IRecommend {
  minFare: number;
}

interface IRecommendByTheme {
  themeId: number;
  themeName: string;
  themeImage: string;
  fare: number;
  departureDate: string;
}

interface IData {
  recommend: IRecommend;
  recommendByTheme: IRecommendByTheme[];
}

interface IProps {
  onClose(): void;
}

export default function ThemeModal({ onClose }: IProps) {
  const { recommendSearchParams, setRecommendSearchParams } =
    useRecommendParamsContext();
  const {
    query: { departure },
  } = useRouter();
  const { data } = useQuery<IData>(GET_RECOMMEND_BY_THEME, {
    variables: { recommendOnly: true, scity: departure },
  });

  if (!data) return null;

  function themeHandler(id: number) {
    setRecommendSearchParams(prev => ({ ...prev, theme: String(id) }));
    onClose();
  }

  const {
    recommend: { minFare },
    recommendByTheme,
  } = data;
  const summaryWithAll = [
    {
      id: All_THEME.theme_id,
      name: All_THEME.theme_name,
      image: All_THEME.theme_image,
      minFare,
    },
    ...recommendByTheme.map(({ themeId, themeName, themeImage, fare }) => ({
      id: themeId,
      name: themeName,
      image: themeImage,
      minFare: fare,
    })),
  ];

  return (
    <div className={cx('ThemeModal')} aria-modal="true">
      <div className={cx('content')}>
        <div className={cx('heading')}>
          <h3 className={cx('title')}>여행 테마</h3>
          <button
            type="button"
            aria-label="닫기"
            className={cx('close')}
            onClick={onClose}
            data-event-nlog="click"
            data-event-area-code="rcm.themeclose"
          />
        </div>
        <div className={cx('panel')}>
          <div className={cx('themes')}>
            {summaryWithAll.map(({ id, name, image, minFare: _minFare }) => (
              <ThemeCard
                key={id}
                themeId={id}
                isSelected={recommendSearchParams.theme === String(id)}
                themeName={name}
                themeImage={image}
                minFare={_minFare}
                onClick={() => themeHandler(id)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
